﻿let $ = require('jquery');
let SizerBreakpoint = require('../SizerBreakpoint');
let Tracker = require('../Tracking/Tracker');

let Description = function (customOptions) {
    let defaults = {
        element: null,
        readMoreSelector: '.jnf-widget-description-read-more',
        readLessSelector: '.jnf-widget-description-read-less',
        contentSelector: '.jnf-widget-description-content',
        readMoreClass: 'jnf-widget-description',
        contentCut: 'jnf-widget-description-cut',
        buttonsWrap: '.buttons-wrapper',
        button: '.jnf-widget-description-donate-button'
    };

    let options = $.extend({}, defaults, customOptions);

    if (options.element === null) {
        throw new Error('element option required');
    }

    let $element = $(options.element);
    let $readMore = $element.find(options.readMoreSelector);
    let $readLess = $element.find(options.readLessSelector);
    let $content = $element.find(options.contentSelector);
    let $buttonWrapper = $element.find(options.buttonsWrap);
    let $display = 'block';

    if ($element[0].className.indexOf('jnf-widget-description-template-7') !== -1) {
        $display = 'inline-block';
    }
    if ($element[0].className.indexOf('sizer-mobile-small') !== -1) {
        $display = 'block';
    }

    let dataLimitAttribute = $element.find(options.contentSelector).attr('data-limit');

    if (typeof dataLimitAttribute !== 'undefined') {
        let wordsFound = 0;
        let wordLimit = parseInt(dataLimitAttribute);

        function limitLength(element) {
            $(element).not('iframe').contents().each((index, child) => {
                if (wordsFound >= wordLimit) {
                    child.remove();
                } else if (child.nodeType !== Node.TEXT_NODE) {
                    limitLength(child);
                } else {
                    let words = child.nodeValue.split(" ");
                    if (wordsFound + words.length >= wordLimit) {
                        child.nodeValue = words.slice(0, wordLimit - wordsFound).join(" ");
                    }
                    wordsFound += words.length;
                }
            });
        }

        let $fullContent = $content.clone();
        let $cutContent = $content.clone();
        limitLength($cutContent);


        let onReadMoreClick = function () {
            $readMore.css('display', 'none');
            $readLess.css('display', $display);
            $content.removeClass('jnf-widget-description-content-visible');
            $content.html($fullContent.html());
            $content.width();
            $content.addClass('jnf-widget-description-content-visible full');
        };

        let onReadLessClick = function () {

            $readLess.css('display', 'none');
            $readMore.css('display', $display);
            $content.removeClass('jnf-widget-description-content-visible full');
            $content.html($cutContent.html());
            $content.width();
            $content.addClass('jnf-widget-description-content-visible');
        };

        if (wordLimit <= wordsFound) {
            //content long enough to show read more button
            $readMore.css('display', 'inline-block');
            $content.html($cutContent.html());
            $readMore.on('click', onReadMoreClick);
            $readLess.on('click', onReadLessClick);
            $element.addClass(options.readMoreClass);
        }
    }

    $content.css('display', 'block');
    $content.addClass('jnf-widget-description-content-visible');

    $(".jnf-widget-description-view-link").click(function (event) {
        event.stopImmediatePropagation();
        var viewLinkElement = $(this).find('a').attr('href');
        if (viewLinkElement) {
            window.location.href = viewLinkElement;
        }
    });

    $('.travelButtonHolder').click(function () {
        window.location = $(this).find('.travelLinkHolder a').attr('href');
    });

    $('.missionButtonHolder').parent().addClass('jnf-widget-description-center');

    new SizerBreakpoint({
        element: $element
    });

    if ($element.hasClass(options.contentCut) && $(options.element).hasClass('sizer-mobile') == false) {
        if ($content[0].offsetHeight < $content[0].scrollHeight ||
                $content[0].offsetWidth < $content[0].scrollWidth) {
            $buttonWrapper.addClass('jnf-widget-description-fade');
            if ($buttonWrapper.find(options.button).length > 0) {
                $buttonWrapper.addClass('jnf-widget-description-fade-button');
            }
            else {
                $buttonWrapper.addClass('jnf-widget-description-fade-link');
            }
        }

        if ($element.find('.jnf-widget-description-link-container').length) {
            $content.css('padding-bottom', '0px');
        }
    }


    const trackingEventName = $element.data('trackingEvent');
    if (trackingEventName) {
        $element.find('.jnf-widget-description-link-container a').each((index, link) => {
            $(link).on('click', () => {
                Tracker.trackGenericEvent(trackingEventName, { page: window.location.pathname })
            });
        });
    }
};

module.exports = Description;